
import { FC } from 'react';
import { Input } from './inputStub';

interface IIntegerInputProps {
  onChange: (value: number | undefined) => void;
  name: string;
  value?: number;
  error?: string;
  readOnly?: boolean;
}

export const IntegerInput: FC<IIntegerInputProps> = ({ onChange, value, error, name, readOnly }) => {
  return <Input name={name} type='number' step='1' disabled={readOnly}
    validation={error ? 'error' : undefined}
    validationMsg={error}
    onChange={(e) => {
      const number = parseInt(e.target.value);
      onChange(isNaN(number) ? undefined : number);
    }}
    value={value}
  />;
};